import { getPasswordRequirements } from "../../../helpers/FormValidation";
import "./PasswordRequirements.scss";

const PasswordRequirements = ({ password }: { password: string }) => {
	if (password === "") return null;

	const requirements = getPasswordRequirements(password);

	return (
		<ul className="password-requirements">
			{requirements.map(({ key, label, met }) => (
				<li
					key={key}
					className={
						met ? "password-requirements__item--met" : "password-requirements__item--unmet"
					}
				>
					<span className="password-requirements__icon">{met ? "✓" : "✗"}</span>
					{label}
				</li>
			))}
		</ul>
	);
};

export { PasswordRequirements };
